import React from "react";

interface GoogleAdProps {
  client?: string;
  slot?: string;
  format?: string;
  responsive?: boolean;
}

const GoogleAd: React.FC<GoogleAdProps> = ({
  client,
  slot,
  format = "auto",
  responsive = true,
}) => {
  return (
    <>
      {typeof window !== "undefined" && (
        <>
          <script
            async
            src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9065232699828870`}
            crossOrigin="anonymous"
          ></script>
          <ins
            className="adsbygoogle w-100 block"
            data-ad-client={client}
            data-ad-slot={slot}
            data-ad-format={format}
            data-full-width-responsive={responsive ? "true" : "false"}
          ></ins>
          <script
            dangerouslySetInnerHTML={{
              __html: "(adsbygoogle = window.adsbygoogle || []).push({});",
            }}
          />
        </>
      )}
    </>
  );
};

export default GoogleAd;
